/* @flow */

import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import SquareArrowUpRightSVG from './icon-square-arrow-up-right.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SquareArrowUpRightSVG {...validProps} />;
}
SvgComponent.iconName = 'squareArrowUpRight';

export const SquareArrowUpRightIcon = svgIconWrapper(SvgComponent);
